// extracted by mini-css-extract-plugin
module.exports = {"strong":"Strong-module--strong--CZjtl"};